import TransitMap from "../components/Map/TransitMap";
export default function InteractiveMap() {
  return (
    <>
      <TransitMap  />
    </>
  );
}
